/**
 * Notification Service Wrapper
 * Minimal wrapper to initialize notifications without direct TypeScript imports
 * Prevents build issues with .ts files in JS React app
 */

export const initializeNotifications = async () => {
    try {
        // Check if browser supports Notifications API
        if (!('Notification' in window)) {
            console.log('ℹ️ This browser does not support notifications');
            return false;
        }

        // Request permission if not already granted
        if (Notification.permission === 'default') {
            const permission = await Notification.requestPermission();
            console.log('🔔 Notification permission:', permission);
            return permission === 'granted';
        }

        // If already granted, return true
        if (Notification.permission === 'granted') {
            console.log('✅ Notifications already enabled');
            return true;
        }

        // If denied, log and return false
        console.log('ℹ️ Notifications are disabled by user');
        return false;
    } catch (error) {
        console.warn('⚠️ Failed to initialize notifications:', error.message);
        return false;
    }
};

export default {
    initialize: initializeNotifications,
};
